<template>
  <v-card>
    <v-card-title class="bg-warning text-white text-h6">Add UK Sample</v-card-title>
    <v-card-text class="mt-3">
      <p class="text-red font-weight-bold mb-4">Completing this form adds a UK sample pack</p>
      <v-form ref="sampleForm">
        <v-row>
          <v-col cols="12">
            <v-select
              v-model="form.materials"
              class="no-padding"
              required
              hide-details
              placeholder="Materials"
              :rules="[(v) => !!v || 'You must select the materials you want']"
              :items="[
                { text: 'Veneer', value: 'veneer' },
                { text: 'Laminate', value: 'laminate' },
                { text: 'Both', value: 'both' }
              ]"
            >
            </v-select>
          </v-col>
          <v-col cols="12" lg="6">
            <v-text-field
              v-model="form.firstName"
              class="no-padding"
              required
              placeholder="First Name"
              :rules="[(v) => !!v || 'First name is required']"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="6">
            <v-text-field
              v-model="form.lastName"
              class="no-padding"
              required
              placeholder="Last Name"
              :rules="[(v) => !!v || 'Last name is required']"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-text-field
          v-model="form.email"
          required
          :rules="emailRules"
          :validate-on="true ? 'blur' : undefined"
          placeholder="Email"
        ></v-text-field>
        <v-text-field
          v-model="form.addressLine1"
          required
          placeholder="Address Line 1"
          :rules="[(v) => !!v || 'Address Line 1 is required']"
        ></v-text-field>
        <v-text-field v-model="form.addressLine2" placeholder="Address Line 2"></v-text-field>
        <v-row>
          <v-col cols="12" lg="6">
            <v-text-field
              v-model="form.city"
              required
              placeholder="City"
              :rules="[(v) => !!v || 'City is required']"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="6">
            <v-text-field
              v-model="form.postcode"
              required
              name="postal-code"
              placeholder="Postcode"
              :rules="[(v) => !!v || 'Postcode is required']"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" variant="text" @click="$emit('cancel', form)">Cancel</v-btn>
      <v-btn color="primary" variant="flat" @click="validate">Add Sample</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { ALLOWED_COUNTRIES_UK } from '@/js/checkoutConfig'

export default {
  name: 'ukSampleForm',
  data() {
    return {
      feedBackText: null,
      form: {
        materials: null,
        firstName: null,
        lastName: null,
        email: null,
        addressLine1: null,
        addressLine2: null,
        city: null,
        postcode: null,
        country: ALLOWED_COUNTRIES_UK[0]
      },
      emailRules: [(v) => !!v || 'E-mail is required', (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid']
    }
  },
  methods: {
    async validate() {
      if (await this.$utils.validateForm(this.$refs.sampleForm)) {
        this.$emit('add', this.form)
      }
    }
  }
}
</script>
